import React, {useState, useEffect} from "react"
import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import Form from "@irati/ui/src/Form"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {H6, Label} from "@irati/ui/src/Typography"
import mfaService from "@irati/auth/services/mfa"
import {MFAPhoneNumber} from "@irati-web/fields/mfa"
import FormattedMessage from "@irati/utils/lang"
import {mfaTracking} from "@irati-tracking/platform"
import {validatedScreen} from "@irati/utils/validation"
import {MFA_TYPE} from "@irati-tracking/platform/mfa"

import {Modal} from "../../BaseModal"
import {ButtonContainer} from "../styled"
import {Screens, SelectScreen} from "../index"

interface Props {
  selectScreen: SelectScreen
  onCancel(): void
  show: boolean
}

const MFAPopupSetup: React.FC<Props> = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [submit, setSubmit] = useState<Promise<any>>(Promise.resolve())

  useEffect(() => {
    if (props.show) {
      mfaTracking.popupSetupShown({type: MFA_TYPE.SMS})
    }
  }, [])

  const handleSuccess = () => {
    if (phoneNumber) {
      setSubmit(
        mfaService.setup(phoneNumber).then(() => {
          props.selectScreen(Screens.SMS_ENTER, {smsAlreadyRequested: true})
          mfaTracking.popupSetupComplete({type: MFA_TYPE.SMS})
        })
      )
    }
  }

  const handleCancel = () => {
    props.onCancel()
    mfaTracking.popupSetupCancel({type: MFA_TYPE.SMS})
  }

  return (
    <Modal show={props.show} header="platform.mfa.setup.title">
      <Label display="block" paddingBottom={2}>
        <FormattedMessage
          id="platform.mfa.setup.bodyWithBoldText"
          values={{
            boldText: (
              <H6 as="strong">
                <FormattedMessage id="platform.mfa.setup.boldText" />
              </H6>
            )
          }}
        />
      </Label>
      <Form>
        <MFAPhoneNumber value={phoneNumber} onChange={setPhoneNumber} />
        <Loading load={submit} useLoader={false} />
        <ButtonContainer>
          <Button onClick={handleCancel} marginRight>
            <FormattedMessage id="platform.mfa.setup.cancel" />
          </Button>
          <ValidationButton onClick={handleSuccess} primary load={submit}>
            <FormattedMessage id="platform.mfa.setup.submit" />
          </ValidationButton>
        </ButtonContainer>
      </Form>
    </Modal>
  )
}

export default validatedScreen(MFAPopupSetup, "MFAPopup")
